import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '0px',
  },
  maps: {
    paddingTop: '15px',
    minHeight: '400px',
  },
  field: {
    padding: '15px 15px 0px 15px',
  },
  icon: {
    color: '#999',
    marginRight: theme.spacing(2),
  },
  searchIcon: {
    color: '#FF9000',
  },
  button: {
    display: 'flex',
    justifyContent: 'space-around',
    width: 'calc(100% - 30px)',
    height: '40px',
    position: 'fixed',
    bottom: 15,
    borderRadius: 5,
    backgroundColor: '#F97F11',
    color: '#FFF',
    '&:hover': {
      backgroundColor: '#F97F11',
    },
  },
  modalAddress: {
    width: '100%',
    background: '#FFF',
    position: '',
    display: 'flex',
    padding: 20,
  },
  formAddress: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space around',
    marginBottom: 10,
  },
  buttonConfirmAddress: {
    display: 'flex',
    width: '100%',
    height: '40px',
    borderRadius: 5,
    backgroundColor: '#FF9000',
    color: '#FFF',
    '&:hover': {
      backgroundColor: '#F97F11',
      opacity: 0.9,
    },
  },
  formAddressTitle: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  inputGroup: {
    display: 'flex',
    marginTop: 30,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dialogContent: {
    marginTop: -20,
  },
  dialogActions: {
    padding: 20,
    marginTop: 10,
  },
  inputNumber: {
    width: '60px',
    maxWidth: '80px',
  },
  inputComplement: {
    padding: 5,
    marginLeft: 10,
    maxWidth: '150px',
    width: '250px',
  },
  favWorkButton: {
    borderColor: '#eee',
    marginTop: 10,
    color: '#999',
    width: '150px',
    fontSize: 14,
  },
  favHouseButton: {
    borderColor: '#eee',
    marginTop: 10,
    color: '#999',
    width: '140px',
  },
}));

export default useStyles;
